module.exports = __webpack_public_path__ + "img/group1811.a57af1b0.svg";